import AddIcon from "@mui/icons-material/Add";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import {
  Box,
  Button,
  IconButton,
  ListItemIcon,
  MenuItem,
  Tooltip,
  Typography,
} from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import axios from "axios";
import React, { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import DownloadIcon from "@mui/icons-material/Download";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ListAltIcon from "@mui/icons-material/ListAlt";
import ButtonTag from "./ButtonTag";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useNavigate, useParams } from "react-router-dom";
import useApi from "../../service/api.service";
import { useQualityData } from "../../context/QualityDataContext";
import { useLoading } from "../../context/LoadingContext";
import DateRangeFilter from "./DateRangeFilter";
import { ClearIcon } from "@mui/x-date-pickers";

const theme = createTheme({
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: "white",
          color: "black",
          border: "1px solid black",
        },
      },
    },
  },
});

const styles = {
  flexBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: "70px",
    overflowX: "auto",
  },
  paddingLeftBox: {
    p: 2,
  },
  companyTypography: {
    display: "flex",
    alignItems: "center",
    fontSize: "25px",
    textTransform: "capitalize",
    fontWeight: 500,
    color: "#404040",
  },
  buttonGroup: {
    display: "flex",
    alignItems: "center",
    // mt: -3,
    // p: 1,
  },
  buttonStyle: {
    textTransform: "capitalize",
    borderRadius: "20px",
    backgroundColor: "#00A398",
    mr: 2,
    "&:hover": {
      backgroundColor: "#00A398",
    },
    whiteSpace: "nowrap",
  },
  goDownloadIcon: {
    color: "white",
    borderRadius: "50%",
    backgroundColor: "#00A398",
    fontSize: "33px",
    padding: "5px",
    marginRight: "16px",
  },
  optionalIdentifierStyle: {
    color: "#FD5707",
    marginRight: "5px",
  },
};
const textStyle = {
  fontSize: "12px",
  marginRight: "10px",
  fontWeight: "500",
};

function InfoboxHeader({
  head,
  page,
  projectId,
  comId,
  fetchCompanyContacts,
  downloadPermission,
  setTypeStatus,
  finalDate,
  setFinalDate,
  productsData,
}) {
  const { id } = useParams();
  const [modalOpen, setModalOpen] = useState(false);
  const [noteModal, setNoteModal] = useState(false);
  const [clientsData, setClientsData] = useState("abc");
  const { loading, setLoading } = useLoading();
  const navigate = useNavigate();
  const API = useApi();

  const [selectedProduct, setSelectedProduct] = useState(null);
  useEffect(() => {
    if (page === "By Products") {
      if (id && productsData) {
        const foundProduct = productsData?.find(
          (product) => product.productSystemId == id
        );
        setSelectedProduct(foundProduct);
      }
    }
  }, [id, productsData, page]);

  const onGoodClick = () => {
    onSubmitButton("Good");
  };

  const onScrapClick = () => {
    onSubmitButton("Scrap");
  };

  const onSubmitButton = async (inspectionStatus) => {
    try {
      setLoading(true);
      const body = {
        predictionStatus: head?.final_status,
        inspectionStatus: inspectionStatus,
      };
      await API.inspectPartById(id, body);
      toast.success("Info Updated Successfully");
      setLoading(false);
      setTypeStatus(true);
      // navigate(`/qualityInfo/${id}`);
    } catch (error) {
      setLoading(false);
      // console.log(error.response.data.error.message)
      toast.error(error?.response?.data?.error?.message);
    }
  };

  // const handleModalClose = () => {
  //   setModalOpen(false);
  // };

  // const handleNoteModalClose = () => {
  //   setNoteModal(false);
  // };

  //   const fetchCompanyData = async () => {
  //     try {
  //       const response1 = await axios.get(
  //         `${BaseURL}/api/v1/company/${localStorage.getItem(
  //           "userid"
  //         )}/get-company-list`
  //       );
  //       setClientsData(response1.data.data);
  //     } catch (error) {
  //       console.error(error);
  //     }
  //   };

  //   useEffect(() => {
  //     fetchCompanyData();
  //   }, []);

  //   const addContact = async (contactInfo) => {
  //     const apiUrl = `${BaseURL}/api/v1/contacts/${localStorage.getItem(
  //       "userid"
  //     )}/${comId}/create-contact`;
  //
  //     try {
  //       const response = await axios.post(apiUrl, contactInfo);
  //       return response.data;
  //     } catch (error) {
  //       throw error;
  //     }
  //   };

  //   const handleAddContact = async (contactInfo) => {
  //     toast
  //       .promise(addContact(contactInfo), {
  //         loading: "Adding New Contact...",
  //         success: (data) => data?.message || "Contact added successfully",
  //         error: (error) =>
  //           error.response?.data?.error?.message || "Failed to add contact.",
  //       })
  //       .then(() => {
  //         fetchCompanyContacts();
  //       })
  //       .catch((error) => {
  //         console.error("Contact addition failed:", error);
  //       });
  //   };

  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
      enabled: false,
      status: false,
    },
  ]);

  const [toggleDateFilter, setToggleDateFilter] = useState(false);

  return (
    <>
      <Box sx={styles.flexBox}>
        <>
          {page === "By Parts" ? (
            <>
              <Box sx={styles.paddingLeftBox}>
                <Typography sx={styles.companyTypography}>
                  Part ID {head?.partCode}
                </Typography>
              </Box>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "20px",
                }}
              >
                {/* <>
                  <ButtonTag
                    name="Good Part"
                    icon={<CheckCircleIcon />}
                    onClick={onGoodClick}
                    backgroundcolor="#34A853"
                  />
                  <ButtonTag
                    name="Scrap Part"
                    icon={<CancelIcon />}
                    onClick={onScrapClick}
                    backgroundcolor="#EA4335"
                  />
                </> */}

                <IconButton
                  variant="contained"
                  sx={{
                    backgroundColor: "#0077B6",
                    padding: "6px",
                    color: "#fff",
                    marginRight: "10px",
                    "&:hover": {
                      backgroundColor: "#0077B6",
                      color: "white",
                    },
                  }}
                  onClick={downloadPermission}
                >
                  <FileDownloadIcon
                    sx={{
                      fontSize: "22px",
                    }}
                  />
                </IconButton>
              </div>
            </>
          ) : (
            <>
              <Box sx={styles.paddingLeftBox}>
                <Typography sx={styles.companyTypography}>
                  Product ID {selectedProduct?.productCode}
                </Typography>
              </Box>
              <div style={{ display: "flex", alignItems: "center" }}>
                {dateRange?.[0]?.enabled && (
                  <Typography sx={textStyle}>
                    From {dateRange?.[0].startDate?.toLocaleDateString("en-US")}
                    {" To "}
                    {dateRange?.[0].endDate?.toLocaleDateString("en-US")}
                  </Typography>
                )}
                {dateRange?.[0]?.enabled && (
                  <IconButton
                    onClick={() => {
                      setDateRange([
                        {
                          enabled: false,
                          startDate: null,
                          endDate: null,
                          key: "selection",
                          status: false,
                        },
                      ]);
                      setFinalDate({
                        startDate: null,
                        endDate: null,
                      });
                    }}
                    sx={{
                      backgroundColor: "white",
                      cursor: "pointer",
                      height: "30px",
                      width: "30px",
                      border: "1px solid #e4e4e4",
                      borderRadius: "20px",
                      marginRight: "10px",
                      fontSize: "12px",
                      "&:hover": {
                        backgroundColor: "#e4e4e4",
                        color: "white",
                      },
                    }}
                  >
                    <ClearIcon
                      size="small"
                      sx={{
                        fontSize: "18px",
                      }}
                    />
                  </IconButton>
                )}

                <Button
                  variant="contained"
                  size="small"
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    columnGap: 1,
                    textTransform: "initial",
                    height: "32px",
                    width: "140px",
                    fontSize: "12px",
                    boxShadow: "none",
                    backgroundColor: "#fff",
                    color: "#404040",
                    fontSize: "12px",
                    border: "1px solid #D4D4D4",
                    borderRadius: "25px",
                    marginRight: "10px",
                    "&:hover": {
                      backgroundColor: "#fff",
                      boxShadow: "none",
                    },
                  }}
                  onClick={() => {
                    setToggleDateFilter(true);
                  }}
                >
                  Date Range
                  <CalendarMonthIcon sx={{ fontSize: "16px" }} />{" "}
                </Button>
              </div>
              {toggleDateFilter && (
                <DateRangeFilter
                  open={toggleDateFilter}
                  onClose={() => {
                    setToggleDateFilter(false);
                  }}
                  onApply={() => {
                    setToggleDateFilter(false);
                    setDateRange([
                      {
                        ...dateRange?.[0],
                        enabled: true,
                        status: !dateRange?.[0]?.status,
                      },
                    ]);
                    setFinalDate({
                      startDate: dateRange?.[0].startDate,
                      endDate: dateRange?.[0].endDate,
                    });
                  }}
                  dateRange={dateRange}
                  onChange={(data) => {
                    setDateRange([
                      {
                        ...data?.[0],
                        status: dateRange?.[0]?.status,
                      },
                    ]);
                  }}
                />
              )}
            </>
          )}
        </>
      </Box>
      <Toaster />
    </>
  );
}

export default InfoboxHeader;
